import React, {Component} from 'react';
import OrderRow from './orderRow';

class Principal extends Component {
  render() {
    const {original, substitute} = this.props;
    if (!original) {
      return null;
    }

    return (
      <OrderRow type='original' disabled={!!substitute} order={original} />
    );
  }
}

export default Principal;
